/**
 * Extracts helpCenterId from a help-center ARI string.
 * ARI format: ari:cloud:help::help-center/{activationId}/{helpCenterId}
 *
 * `customerHubId` in the widget config IS the helpCenterAri.
 * (see WidgetServerConfig type in conversation-assistant-widget-installer:
 *  "Customer Hub ID / Help Center ARI")
 *
 * The extracted helpCenterId is the help-kosh customer experience ID
 * required by POST /conversation/livechat/direct (BEARS-1249).
 */
const HELP_CENTER_ARI_PREFIX = 'ari:cloud:help::help-center/';

export const extractHelpCenterIdFromAri = (ari: string | null | undefined): string | null => {
	if (!ari?.startsWith(HELP_CENTER_ARI_PREFIX)) {
		return null;
	}
	// Expected format: ari:cloud:help::help-center/{activationId}/{helpCenterId}
	const pathSegments = ari.slice(HELP_CENTER_ARI_PREFIX.length).split('/');
	if (pathSegments.length !== 2) {
		return null;
	}
	const helpCenterId = pathSegments[1];
	return helpCenterId || null;
};
